<template>
  <modal
    v-if="visible"
    :visible="visible"
    @click-outside-modal="$emit('close')"
  >
    <div
      class="flex max-h-[500px] w-full max-w-2xl justify-center px-4 lg:max-h-full"
      style="minwidth: 30vw"
    >
      <div
        class="relative flex w-full flex-col items-start overflow-scroll rounded bg-white p-8"
        :class="containerClass"
      >
        <img
          class="absolute right-4 top-4 h-4 w-4 cursor-pointer"
          src="@/assets/close-icon.svg"
          alt="close icon"
          @click="$emit('close')"
        />

        <div class="flex flex-col">
          <h3 class="text-left text-3xl text-dark-blue">
            Rate Confirmation Terms
          </h3>
          <!-- <slot></slot> -->
          <div class="mt-2 text-left text-base text-body-color">
            Please review and accept the following terms and conditions as
            specified by {{ termsRate?.issuer?.legal_name }} before reviewing
            this rate confirmation.
          </div>
          <div
            class="mb-4 mt-6 rounded-md border border-placeholder-gray bg-off-white p-4 py-6 text-left text-base text-sm text-body-color"
          >
            {{ terms?.terms || terms }}
          </div>
        </div>
        <div class="w-full pb-6 pt-2">
          <radio-button-large
            :item="acceptConfirmationText"
            :active="checkboxConfirmed"
            :handle-select="handleAccept"
            name="confirmation"
          />
        </div>
        <div class="mt-4 flex w-full justify-end gap-4">
          <!-- <div class="inline-block"> -->
          <div class="w-40 lg:w-24">
            <button-main
              variant="secondary"
              @click="$emit('close')"
            >
              Cancel
            </button-main>
          </div>
          <div class="w-40">
            <button-main
              :disabled="!checkboxConfirmed"
              :is-loading="isLoading"
              @click="acceptTerms()"
            >
              Accept Terms
            </button-main>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal.vue';
import ButtonMain from '@/components/Button.vue';
import {
  isSuccessfulServerResponse,
  toastResponse,
} from '@/common/handleServerResponse';
import RadioButtonLarge from '@/components/RadioButtonLarge.vue';
// import { toRef } from "vue";

export default {
  name: 'TermsModal',
  components: {
    Modal,
    ButtonMain,
    RadioButtonLarge,
  },
  props: {
    visible: Boolean,
    containerClass: String,
    terms: String,
    termsRate: Object,
  },
  emits: ['close'],
  setup(_, { emit }) {
    const onCancel = () => {
      emit('close');
    };

    return {
      onCancel,
    };
  },
  data() {
    return {
      checkboxConfirmed: false,
      acceptConfirmationText: 'I accept the terms and conditions listed above.',
    };
  },
  // computed: {
  //   rateDetail() {
  //     return this.$store.state.rates.current_rate;
  //   }
  // },
  methods: {
    async acceptTerms() {
      this.isLoading = true;
      const id = this.$router?.currentRoute?.value?.params?.id;

      const res = await this.$store.dispatch('rates/acceptRateTerms', {
        id: id,
      });
      if (isSuccessfulServerResponse(res)) {
        toastResponse(this, res, 'Terms accepted successfully');
        await this.$store.dispatch('rates/getRateDetail', id);

        this.$emit('close', this.termsRate);
      }
      this.isLoading = false;
    },
    async handleAccept(e) {
      this.checkboxConfirmed = e?.target?.checked;
    },
  },
};
</script>
